import { Stack, Typography } from '@mui/material';

import StatusBar from '@/designs-dev/device/StatusBar';
import TabBar from '@/designs-dev/device/TabBar';
import Card from '@/components/wrapped/Card';
import ScreenRoot from '@/components/wrapped/ScreenRoot';
import Body from '@/karehero-app/shell/Body';
import Navigation from '@/karehero-app/shell/Navigation';
import ClaimRow from '@/karehero-app/tell-us-once/intake/ClaimRow';
import { HOME } from '@/james-playground/aa-family-claim/AaFamilyClaim.content';

/**
 * App home, with the claim waiting at the top. Leaving the claim lands here,
 * so leaving is somewhere to be rather than a door closing, and coming back is
 * one tap on the claim's own row.
 *
 * The row is the intake's claim row, lead-coloured because it is the one to do
 * next. Its line is the hub's headline, in words: the size of the form is
 * never shown.
 */
const ClaimHomeScreen = ({
  t,
  progress,
  initials,
  onContinue,
}: {
  t: (text: string) => string;
  /** Where the claim stands, as the hub says it. */
  progress: string;
  /** The account holder's initials, for the avatar. */
  initials: string;
  onContinue: () => void;
}) => (
  <ScreenRoot>
    <StatusBar />
    <Navigation title={t('Margaret')} avatarInitials={initials} />
    <Body pb='96px'>
      <Stack spacing={3}>
        <Stack spacing={1.5}>
          <Typography variant='h3'>{HOME.carryOn}</Typography>
          <ClaimRow
            icon='file-lines'
            name={HOME.claimName}
            description={t(HOME.claimDescription)}
            count={progress}
            lead
            onClick={onContinue}
          />
        </Stack>
        <Stack spacing={1.5}>
          <Typography variant='h3'>{t(HOME.more)}</Typography>
          {HOME.cards.map((card) => (
            <Card
              key={card.title}
              titleVariant='h4'
              title={card.title}
              subtitle={t(card.subtitle)}
              onClick={() => {}}
            />
          ))}
        </Stack>
      </Stack>
    </Body>
    <TabBar active='home' />
  </ScreenRoot>
);

export default ClaimHomeScreen;
